import { DeleteOutlined } from "@ant-design/icons";
import { Button, Input, DatePicker, Checkbox, Select, Divider } from "antd";
import TextArea from "antd/es/input/TextArea";
import moment from "moment";
import { useState } from "react";

interface TExpForm {
  data: any;
  setData: (value: any, key: any, index: number) => void;
  index: number;
  removeForm: (index: number) => void;
}

const ExpForm: React.FC<TExpForm> = ({ data, setData, index, removeForm }) => {
  const [currentlyWorking, setCurrentlyWorking] = useState(false);

  const handleChangeCurrentlyWorking = () => {
    if (!currentlyWorking == true) {
      setData(getTodayDate(), "end_date", index);
    }
    setCurrentlyWorking(!currentlyWorking);
  };

  const getTodayDate = () => {
    return moment().format("YYYY-MM-DD");
  };

  const disableFutureDates = (current: any) => {
    return current && current > moment().endOf("day");
  };

  return (
    <div className="exp-form">
      {index !== 0 && (
        <Button className="remove-form-btn" onClick={() => removeForm(index)}>
          <DeleteOutlined />
        </Button>
      )}
      <div className="row gy-3 gx-3">
        <div className="col-12">
          <div className="form-group">
            <div className="title">Title</div>
            <Input
              size="large"
              onChange={(e) => setData(e.target.value, "position_name", index)}
              value={data?.position_name}
              variant="filled"
            />
          </div>
        </div>
        <div className="col-6">
          <div className="form-group">
            <div className="title">Start Date</div>
            <DatePicker
              disabledDate={disableFutureDates}
              className="w-100"
              size="large"
              variant="filled"
              value={
                data?.start_date ? moment(data?.start_date, "YYYY-MM-DD") : null
              }
              onChange={(date, dateString) =>
                setData(dateString, "start_date", index)
              }
            />
          </div>
        </div>
        <div className="col-6">
          <div className="form-group">
            <div className="title">End Date</div>
            {currentlyWorking ? (
              <Input size="large" value={"Present"} variant="filled" disabled />
            ) : (
              <DatePicker
                disabledDate={disableFutureDates}
                className="w-100"
                variant="filled"
                size="large"
                value={
                  data?.end_date ? moment(data?.end_date, "YYYY-MM-DD") : null
                }
                onChange={(date, dateString) =>
                  setData(dateString, "end_date", index)
                }
              />
            )}
          </div>
        </div>
        <div className="col-12">
          <div className="form-group">
            <Checkbox
              value={currentlyWorking}
              onChange={handleChangeCurrentlyWorking}
            >
              <span>I'm currently working in this position</span>
            </Checkbox>
          </div>
        </div>
        <div className="col-12">
          <div className="form-group">
            <div className="title">Description</div>
            <TextArea
              rows={5}
              variant="filled"
              onChange={(e) => setData(e.target.value, "description", index)}
              value={data?.description}
            />
          </div>
        </div>
        <div className="col-12">
          <div className="form-group">
            <div className="title">Skills</div>
            <Select
              mode="tags"
              style={{ width: "100%" }}
              size="large"
              placeholder="Press enter to add"
              value={data?.skills}
              variant="filled"
              onChange={(value) => setData(value, "skills", index)}
            />
          </div>
        </div>
      </div>
      <Divider />
    </div>
  );
};

export default ExpForm;